import FormErrors from "Components/Shared/FormErrors";
import { FormikErrors } from "formik";
import { isEmpty } from "lodash";
import React, { Fragment, useState } from "react";
import { Button, Confirm, Divider, Icon } from "semantic-ui-react";

type FormSubmitProps = {
  errors: FormikErrors<any>;
  name: string;
  submitting?: boolean;
  onCancel?: Function;
  onDelete?: Function;
};
function FormSubmit({
  errors,
  name,
  submitting,
  onCancel,
  onDelete,
}: FormSubmitProps) {
  const [confirmState, setConfirmState] = useState(false);
  return (
    <Fragment>
      <Divider />
      <Button primary type='submit' disabled={submitting || !isEmpty(errors)}>
        {submitting && <Icon name='spinner' />}
        {name}
      </Button>
      {onCancel && (
        <Button secondary type='button' onClick={() => onCancel()}>
          Cancel
        </Button>
      )}
      {onDelete && (
        <Fragment>
          <Button
            floated='right'
            basic
            color='red'
            type='button'
            onClick={() => setConfirmState(true)}
          >
            <Icon name='trash' />
            Delete
          </Button>
          <Confirm
            open={confirmState}
            onCancel={() => setConfirmState(false)}
            onConfirm={() => {
              setConfirmState(false);
              onDelete();
            }}
          />
        </Fragment>
      )}

      <FormErrors errors={errors} />
    </Fragment>
  );
}

export default FormSubmit;
